import { render } from "./AssignControlManagement.vue?vue&type=template&id=0fe22742&scoped=true"
import script from "./AssignControlManagement.vue?vue&type=script&lang=js"
export * from "./AssignControlManagement.vue?vue&type=script&lang=js"

import "./AssignControlManagement.vue?vue&type=style&index=0&id=0fe22742&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe22742"]])

export default __exports__